import React, { useEffect, useState } from "react";

const StravaOAuthRedirect = () => {
  const [message, setMessage] = useState("Redirecting...");

  useEffect(() => {
    // Get the 'code' from the URL
    const params = new window.URLSearchParams(window.location.search);
    const code = params.get("code");

    if (code) {
      // Redirect to your app using deep link
      window.location.href = `trainingamigo://callback?code=${code}`;
    } else {
      setMessage("No code received from Strava.");
    }
  }, []);

  return (
    <div>
      <h2>{message}</h2>
    </div>
  );
};

export default StravaOAuthRedirect;